import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { GuiUtils } from 'src/modules/utils/misc/gui-utils';
import { GradeType } from '../../shared/grade-type.enum';
import { ExamGrade } from '../../shared/exam-grade.entity';
import { ConductGrade } from '../../shared/conduct-grade.entity';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Utils } from 'src/modules/utils/shared/utils';
import { SmTableCellEditorComponent } from 'src/modules/sm-base/components/sm-table-cell-editor/sm-table-cell-editor.component';

@Component({
    selector: 'sm-grade-editor',
    templateUrl: './grade-editor.component.html',
    styleUrls: ['./grade-editor.component.scss']
})
export class GradeEditorComponent {
     
    _GuiUtils = GuiUtils;
    _GradeType = GradeType;

    app = inject(MainAppService);

    @Input()
    gradeType = GradeType.percent;
    
    tableCellEditor: SmTableCellEditorComponent;

    _value: ExamGrade | ConductGrade = null;
    grade: any = "";
    isExamGrade = false;
    @Output() valueChange = new EventEmitter<ExamGrade | ConductGrade>();

    @ViewChild('inputRef', { static: true}) inputRef!: ElementRef;

    ngDoCheck(): void {
        //Das benötigen wir, weil jedes Mal, wenn in einer Tabelle ArrowDown/Up gedrückt wird um zur nächsten Zelle zu gelangen,
        //wird spin aufgerufen und bei leerer Eingabe der Wert 0 gesetzt, was nicht sein soll.
        if (this.inputRef != null) {
           (this.inputRef as any).spin = () => {
           };
        }       
    }
  
    @Input()
    set value(value: ExamGrade | ConductGrade) {
        this._value = value;
        this.grade = this._value.grade >= 0 && this._value.grade <= 999 ? this._value.grade : null;
        this.isExamGrade = this._value instanceof ExamGrade;
    }

    focus(event: any): void {
        GuiUtils.selectAll(event);    }
          
    change(): void {       
        this._value.grade = Utils.toNumber(this.grade, false, false, -1);
        this.valueChange.emit(this._value);
    }

    async editGrade(event: any, grade: ExamGrade | ConductGrade): Promise<void> {
        let editedGrade = grade;
        let editGradeForm = new FrontendFormDefinition([
            new FrontendFieldDefinition("title", "Thema (abweichend)", FrontendFieldType.text),
            new FrontendFieldDefinition("date", "Datum (abweichend)", FrontendFieldType.datePicker)
        ]);
        editGradeForm.fill(grade);
        if (await this.app.messageDialog.form(editGradeForm, "Note bearbeiten", [this.app.messageDialog.save, this.app.messageDialog.cancel]) == "save") {
            editGradeForm.get(editedGrade);
          //  this.gradeUpdated();
        }
    }

    keyDown(event: KeyboardEvent): void {
        if (this.tableCellEditor != null) {
            if (event.key == "ArrowDown") {
                this.change();
                this.tableCellEditor.params.api.stopEditing();
                this.tableCellEditor.params.api.tabToNextCell();
                this.tableCellEditor.params.api.startEditingCell({
                    rowIndex: this.tableCellEditor.params.api.getFocusedCell().rowIndex,
                    colKey: this.tableCellEditor.params.api.getFocusedCell().column.getColId()
                });                
            }
            else if (event.key == "ArrowUp") {
                this.change();
                this.tableCellEditor.params.api.stopEditing();
                this.tableCellEditor.params.api.tabToPreviousCell();
                this.tableCellEditor.params.api.startEditingCell({
                    rowIndex: this.tableCellEditor.params.api.getFocusedCell().rowIndex,
                    colKey: this.tableCellEditor.params.api.getFocusedCell().column.getColId()
                });
                
            }
        }
    }

    setContext(context: any): void {
    }
}
